import React from 'react';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function CustomYearPicker({
    name,
    onChange,
    onBlur,
    value,
    error,
    helperText,
    FormHelperTextProps,
    disabled = false,
    minDate,
    maxDate,
    no_border = false,
    readOnly=false,
    views = ['month', 'year'], // customizable views
}) {
    let placeholder = '';

    if (views.includes('day')) {
        placeholder = 'DD-MM-YYYY';
    } else if (views.includes('month') && views.includes('year')) {
        placeholder = 'MM-YYYY';
    } else if (views.includes('year')) {
        placeholder = 'YYYY';
    } else if (views.includes('month')) {
        placeholder = 'MM';
    } 

    const inputStyles = {
        '& .MuiInputBase-input.MuiOutlinedInput-input': {
            padding: '8px 14px',
            fontSize: '15px',
            height: '25px',
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#272727",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: no_border ? 'none' : '',
        }
    };

    const pickerOutlineStyles = {
        '& .MuiOutlinedInput-root': {
            fontFamily: 'Poppins',
            fontSize: '15px',
            '& fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
            '&:hover fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
            '&.Mui-focused fieldset': {
                borderColor: no_border ? 'white' : '#C0C0C0',
            },
        },
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
                views={views}
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
                onChange={(date) => onChange && onChange(date)}
                value={value}
                name={name}
                onBlur={onBlur}
                className='custom-datepicker-input-class'
                autoComplete="off"
                size="small"
                slotProps={{
                    // actionBar: {
                    //     actions: ['clear'],
                    // },
                    textField: {
                        helperText: helperText || '',
                        error: !!error,
                        fullWidth: true,
                        placeholder: placeholder,
                        FormHelperTextProps: FormHelperTextProps || {},
                        inputProps: { readOnly: readOnly },
                    },
                }}
                sx={{ ...pickerOutlineStyles, ...inputStyles }}
            />
        </LocalizationProvider>
    );
}

export default CustomYearPicker;
